import { http } from ".";

interface User {
  uuid: string;
  username: string;
  phonenumber?: string;
  email?: string;
}

interface ReactivateResponse {
  refresh: string;
  user: User;
  token?: string;
}

export async function requestReactivateAccount({
  email,
  username,
  password,
}: {
  email?: string;
  username?: string;
  password: string;
}) {
  return http.post<ReactivateResponse>("/reactivate-account/", {
    ...(email ? { email } : { username }),
    password,
  });
}
